"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    SYNC_COMPLETE: 'complete',
    SYNC_BASIC_INFO: 'basic_info',
    SYNC_RELATIONS: 'user_relationships',
    SYNC_USER_ROLE: 'user_role',
    SYNC_TUTOR_SUBJECT: 'tutor_subject',
    SYNC_KEY_CONTACT: 'primary_key_contact',
};
//# sourceMappingURL=messageModes.js.map